import { UserRoles } from '../../constants/UserRoles';
import {
  AppointmentsTab,
  DocumentsTab,
  OnboardingTab,
  ProfileTab,
} from './constant';
import { User, UserProfileTab } from './types';

// All these condions are derived from the requirements mentioned here on this JIRA card
// https://i2itherapy.atlassian.net/browse/ICON-2401

// Access control for therapist can access their own client's profile, appointment and document
// is handled on the API side only, on FE side we are not doing anything for that
// When any therapist try to access a client which is not theirs, the API will call to fetch the details will fail.
export const ClientTabs: UserProfileTab[] = [
  {
    ...ProfileTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.id === userProfileDetails?.id ||
        loggedInUser?.user_type?.includes(UserRoles.THERAPIST) ||
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...AppointmentsTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.id === userProfileDetails?.id ||
        loggedInUser?.user_type?.includes(UserRoles.THERAPIST) ||
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...OnboardingTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...DocumentsTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.id === userProfileDetails?.id ||
        loggedInUser?.user_type?.includes(UserRoles.THERAPIST) ||
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
];

export const TherapistTabs: UserProfileTab[] = [
  {
    ...ProfileTab,
    isVisible: () => {
      return true;
    },
  },
  {
    ...AppointmentsTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.id === userProfileDetails?.id ||
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...OnboardingTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        userProfileDetails &&
        (loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
          loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN))
      );
    },
  },
  {
    ...DocumentsTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.id === userProfileDetails?.id ||
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
];

export const SchedulerAndAdminTabs: UserProfileTab[] = [
  {
    ...ProfileTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.id === userProfileDetails?.id ||
        loggedInUser?.user_type?.includes(UserRoles.THERAPIST) ||
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...AppointmentsTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...OnboardingTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  },
  {
    ...DocumentsTab,
    isVisible: (userProfileDetails: User, loggedInUser: User) => {
      return (
        loggedInUser?.user_type?.includes(UserRoles.SCHEDULER) ||
        loggedInUser?.user_type?.includes(UserRoles.PRACTICE_ADMIN)
      );
    },
  }
];
